const prefix = 'AUTH_ACTIONS_';
export const LOGIN_SUCCESS = `${prefix}LOGIN_SUCCESS`;
export const LOGOUT_SUCCESS = `${prefix}LOGOUT_SUCCESS`;

// Sagas
export const REQUEST_OTP = `${prefix}REQUEST_OTP`;
export const VERIFY_OTP = `${prefix}VERIFY_OTP`;
export const LOGOUT = `${prefix}LOGOUT`;
